import { useMemo } from "react";
import { useRouter } from "@edreamsodigeo/frontend-core";

import { FeeSelected } from "~/generated/graphql";

const FEE_SELECTED_REGEX = new RegExp(/feeSelected=(\d)/);

const FEE_SELECTED_MAPPER = [FeeSelected.FullPrice, FeeSelected.PrimePrice];

const useFeeSelectedFromUrl = (): boolean => {
  const { pathname } = useRouter();
  const feeSelected = useMemo(() => {
    const [, feeSelectedFromUrl] = pathname.match(FEE_SELECTED_REGEX) || [];
    return parseInt(feeSelectedFromUrl, 10);
  }, [pathname]);

  return (
    !isNaN(feeSelected) &&
    FEE_SELECTED_MAPPER[feeSelected] === FeeSelected.PrimePrice
  );
};

export default useFeeSelectedFromUrl;
